import { PathWithId } from "@constellation-academy/epic-ui";
import { MessageDefinitionEditPath } from "../message-definition-edit/message-definition-edit.paths";

export class MessageDefinitionsPath extends PathWithId<typeof MessageDefinitionsPath> {
	static readonly pathKey = "messageDefinitions";
	static readonly pathName = "message-definitions";
	static readonly idKey = "messageDefinitionId";
	static readonly childPaths = [MessageDefinitionEditPath];
}
